// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from '../../components/ui/Header';
// import Sidebar from '../../components/ui/Sidebar';
// import PerformanceMetrics from './components/PerformanceMetrics';
// import EquityCurveChart from './components/EquityCurveChart';
// import PnLBreakdownChart from './components/PnLBreakdownChart';
// import PerformanceHeatmap from './components/PerformanceHeatmap';
// import TradeLogTable from './components/TradeLogTable';
// import AdvancedMetrics from './components/AdvancedMetrics';
// import BotControlPanel from './components/BotControlPanel';
// import Icon from '../../components/AppIcon';
// import Button from '../../components/ui/Button';
// import ActiveBotTabs from 'components/ActiveBotTabs';

// const BotAnalytics = () => {
//   const navigate = useNavigate();
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [selectedTimeRange, setSelectedTimeRange] = useState('30d');
//   const [isLoading, setIsLoading] = useState(true);

//   // Mock data for performance metrics
//   const performanceMetrics = [
//     {
//       id: 1,
//       type: 'roi',
//       label: 'Total ROI',
//       value: 24.67,
//       change: 3.2,
//       period: 'Last 30 days'
//     },
//     {
//       id: 2,
//       type: 'pnl',
//       label: 'Total P&L',
//       value: 12847.50,
//       change: 8.5,
//       period: 'All time'
//     },
//     {
//       id: 3,
//       type: 'winrate',
//       label: 'Win Rate',
//       value: 68.4,
//       change: -2.1,
//       period: 'Last 100 trades'
//     },
//     {
//       id: 4,
//       type: 'trades',
//       label: 'Active Trades',
//       value: 3,
//       change: 0,
//       period: 'Currently running'
//     }
//   ];

//   // Mock equity curve data
//   const equityCurveData = Array.from({ length: 90 }, (_, i) => {
//     const date = new Date();
//     date?.setDate(date?.getDate() - (89 - i));
//     const baseEquity = 50000;
//     const trend = i * 150;
//     const volatility = Math.sin(i * 0.1) * 2000 + Math.random() * 1000 - 500;
//     const equity = baseEquity + trend + volatility;
//     const maxEquity = Math.max(baseEquity, equity);
//     const drawdown = ((maxEquity - equity) / maxEquity) * -100;
    
//     return {
//       date: date?.toISOString(),
//       equity: Math.max(baseEquity * 0.8, equity),
//       drawdownEquity: equity * (1 + drawdown / 100),
//       drawdown: drawdown
//     };
//   });

//   // Mock P&L breakdown data
//   const pnlBreakdownData = Array.from({ length: 30 }, (_, i) => {
//     const date = new Date();
//     date?.setDate(date?.getDate() - (29 - i));
//     return {
//       date: date?.toISOString(),
//       pnl: (Math.random() - 0.4) * 500,
//       trades: Math.floor(Math.random() * 10) + 1
//     };
//   });

//   // Mock heatmap data
//   const heatmapData = Array.from({ length: 30 }, (_, i) => {
//     const date = new Date();
//     date?.setDate(date?.getDate() - (29 - i));
//     return {
//       date: date?.toISOString(),
//       pnl: (Math.random() - 0.4) * 300,
//       roi: (Math.random() - 0.4) * 15,
//       trades: Math.floor(Math.random() * 8) + 1,
//       winrate: Math.random() * 100
//     };
//   });

//   // Mock trade log data
//   const tradeLogData = Array.from({ length: 50 }, (_, i) => {
//     const pairs = ['BTC/USDT', 'ETH/USDT', 'ADA/USDT', 'DOT/USDT', 'LINK/USDT'];
//     const exchanges = ['Binance', 'KuCoin', 'Bybit'];
//     const sides = ['long', 'short'];
    
//     const date = new Date();
//     date?.setHours(date?.getHours() - i * 2);
    
//     const side = sides?.[Math.floor(Math.random() * sides?.length)];
//     const entryPrice = 30000 + Math.random() * 20000;
//     const exitPrice = entryPrice * (1 + (Math.random() - 0.45) * 0.1);
//     const quantity = Math.random() * 0.5 + 0.1;
//     const pnl = (exitPrice - entryPrice) * quantity * (side === 'short' ? -1 : 1);
//     const roi = ((exitPrice - entryPrice) / entryPrice) * 100 * (side === 'short' ? -1 : 1);

//     return {
//       id: i + 1,
//       date: date?.toISOString(),
//       pair: pairs?.[Math.floor(Math.random() * pairs?.length)],
//       exchange: exchanges?.[Math.floor(Math.random() * exchanges?.length)],
//       side,
//       entryPrice,
//       exitPrice,
//       quantity,
//       pnl,
//       roi
//     };
//   });

//   // Mock advanced metrics
//   const advancedMetrics = {
//     sharpe: 1.85,
//     sortino: 2.34,
//     calmar: 1.67,
//     maxDrawdown: -12.4,
//     volatility: 18.7,
//     beta: 1.23
//   };

//   // Mock bot data
//   const botData = {
//     name: "Golden Cross Strategy",
//     status: "active",
//     runningTime: "15d 8h 23m",
//     strategy: "Moving Average Crossover",
//     totalTrades: 247,
//     successRate: 68.4,
//     totalPnL: 12847.50,
//     roi: 24.67
//   };

//   useEffect(() => {
//     // Simulate loading
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, []);

//   const handleBotAction = async (action) => {
//     console.log('Bot action:', action);
    
//     // Simulate API call
//     await new Promise(resolve => setTimeout(resolve, 1000));
    
//     switch (action) {
//       case 'pause': console.log('Bot paused');
//         break;
//       case 'resume': console.log('Bot resumed');
//         break;
//       case 'stop': console.log('Bot stopped');
//         break;
//       case 'restart': console.log('Bot restarted');
//         break;
//       case 'clone': navigate('/bot-creation-wizard');
//         break;
//       case 'adjust-settings': navigate('/bot-details');
//         break;
//       case 'export-pdf':
//       case 'export-csv': case'export-excel':
//         console.log(`Exporting ${action?.split('-')?.[1]} report`);
//         break;
//       case 'delete':
//         console.log('Bot deleted');
//         navigate('/bot-marketplace');
//         break;
//       default:
//         console.log('Unknown action:', action);
//     }
//   };

//   const timeRanges = [
//     { value: '24h', label: '24H' },
//     { value: '7d', label: '7D' },
//     { value: '30d', label: '30D' },
//     { value: '90d', label: '90D' },
//     { value: '1y', label: '1Y' }
//   ];

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-background">
        
//           <div className="p-6">
//             <div className="flex items-center justify-center h-96">
//               <div className="text-center">
//                 <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
//                 <p className="text-muted-foreground">Loading bot analytics...</p>
//               </div>
//             </div>
//           </div>
       
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-background">
   
//         <div className="p-6 space-y-8">
//           {/* Page Header */}
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//             <div>
//               <h1 className="text-3xl font-bold text-foreground">Bot Analytics</h1>
//               <p className="text-muted-foreground mt-2">
//                 Comprehensive performance analysis and trading insights for your bot strategies
//               </p>
//             </div>
//             <div className="flex items-center space-x-3">
//               <div className="flex bg-muted rounded-lg p-1">
//                 {timeRanges?.map((range) => (
//                   <Button
//                     key={range?.value}
//                     variant={selectedTimeRange === range?.value ? "secondary" : "ghost"}
//                     size="sm"
//                     onClick={() => setSelectedTimeRange(range?.value)}
//                     className="px-3 py-1 text-xs"
//                   >
//                     {range?.label}
//                   </Button>
//                 ))}
//               </div>
//               <Button variant="outline" onClick={() => navigate('/bot-details')}>
//                 <Icon name="Settings" size={16} className="mr-2" />
//                 Bot Settings
//               </Button>
//             </div>
//           </div>

//           {/* Performance Metrics */}
//           <PerformanceMetrics metrics={performanceMetrics} />

//           {/* Charts Section */}
//           <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
//             <EquityCurveChart data={equityCurveData} />
//             <PnLBreakdownChart data={pnlBreakdownData} />
//           </div>

//           {/* Performance Heatmap */}
//           <PerformanceHeatmap data={heatmapData} />

//           {/* Advanced Metrics */}
//           <AdvancedMetrics metrics={advancedMetrics} />

//           {/* Trade Log */}
//           <TradeLogTable trades={tradeLogData} />

//           {/* Bot Control Panel */}
//           <BotControlPanel botData={botData} onAction={handleBotAction} />

//           {/* Quick Navigation */}
//           <div className="bg-card border border-border rounded-xl p-6 trading-shadow">
//             <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//               <Button
//                 variant="outline"
//                 onClick={() => navigate('/bot-marketplace')}
//                 className="flex items-center justify-center h-12"
//               >
//                 <Icon name="Store" size={20} className="mr-2" />
//                 Bot Marketplace
//               </Button>
//               <Button
//                 variant="outline"
//                 onClick={() => navigate('/bot-creation-wizard')}
//                 className="flex items-center justify-center h-12"
//               >
//                 <Icon name="Wrench" size={20} className="mr-2" />
//                 Create New Bot
//               </Button>
//               <Button
//                 variant="outline"
//                 onClick={() => navigate('/backtesting-engine')}
//                 className="flex items-center justify-center h-12"
//               >
//                 <Icon name="TrendingUp" size={20} className="mr-2" />
//                 Backtest Strategy
//               </Button>
//               <Button
//                 variant="outline"
//                 onClick={() => navigate('/paper-trading')}
//                 className="flex items-center justify-center h-12"
//               >
//                 <Icon name="FileText" size={20} className="mr-2" />
//                 Paper Trading
//               </Button>
//             </div>
//           </div>
//         </div>
     
//     </div>
//   );
// };

// export default BotAnalytics;

import ActiveBotTabs from 'components/ActiveBotTabs'
import TradeHistoryTable from 'components/TradeHistoryTable'
import React from 'react'

function index() {
  return (
    <div>
       <div className="min-h-screen bg-background">
   
        <div className="p-6 space-y-8">
       <ActiveBotTabs />
       <TradeHistoryTable />
       </div>
       </div>
    </div>
  )
}

export default index
